/// <reference path="ListenerManager.js" />

class Window {
	constructor() {
		this.listenerManager = new ListenerManager();
		this.listenerManager.safeObserve(window, 'keypress', this.onKeyPress.bind(this));
		this.uniqueId = 1;
		this.escapeHandlers = new Map();
	}

	onKeyPress(ev) {
		if (ev.keyCode == 27) {
			if (this.performEscapeActions()) {
				ev.preventDefault();
				ev.stopPropagation();
			}
		}
	}

	performEscapeActions() {
		var res = false;
		this.escapeHandlers.forEach(function(eh) {
			eh.value();
			res = true;
		});
		return res;
	}

	registerEscapeHandler(fn) {
		this.escapeHandlers.set(this.uniqueId, fn);
		return this.uniqueId++;
	}

	unregisterEscapeHandler(id) {
		this.escapeHandlers.unset(id);
	}
}
